module.exports = __webpack_public_path__ + "static/media/home_eth.1e5672d8.svg";